import { useMemo } from 'react';
import type { Music24Capabilities } from 'fym-common/src/license/music24Plans';
import { useMusic24Capabilities } from './useMusic24Capabilities';
import { plansForFeature, SMLUpgradeFeature } from '../config/music24PlanCapabilities';
import { Music24Plan } from '../config/music24StripePlans';

export interface NextPlanForFeature {
  current: Music24Capabilities;
  /** The cheapest sold plan that gives more of `feature` than the caller's own plan. `null` when
   * no plan has more — the caller already holds the top limit for it. */
  nextPlan: Music24Plan | null;
}

/**
 * The caller's plan, and the cheapest plan that gives more of `feature` — the same pair
 * `LockedControl`'s chip and `pickPlanForFeature` name. Shared by every "X gives you Y" note
 * (seats in `useSeatUpgradePlan`, artists in the switcher's at-limit box) so they never disagree.
 */
export function useNextPlanForFeature(feature: SMLUpgradeFeature): NextPlanForFeature {
  const current = useMusic24Capabilities();
  const nextPlan = useMemo(() => plansForFeature(feature, current)[0] ?? null, [current, feature]);
  return { current, nextPlan };
}
